import { createFileRoute, useNavigate, useRouter } from '@tanstack/react-router';
import { Button, Form, FormInstance, Input } from 'antd';
import CustomRadioGroup from '../../../../components/CustomRadioGroup';
import { useForm } from 'antd/es/form/Form';
import { IconUsersGroup } from '@tabler/icons-react';
import * as React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiV1 } from '../../../../utils/apiClient';
import { z } from 'zod';
import { zodToAntdRules } from '../../../../utils/form-field-validators/formFieldRules';
import { customersFilterSchema, CustomersGroupType } from '@next-is-free-monorepo/next-is-free-types';
import BackButton from '../../../../microcomponents/BackButton';
import CustomersFilter from '../../../../components/customers/CustomersFilter';
import RadioCards from '../../../../components/Inputs/RadioCards';
import {
  AiBrain01Icon,
  Edit01Icon,
  BirthdayCakeIcon,
  Clock02Icon,
  Hold01Icon,
  AddTeam02Icon
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import CustomersRulesInput from '../../../../components/Inputs/CustomersRulesInput';
import FilterBuilder from '../../../../components/Inputs/CustomersRulesInput';


export const Route = createFileRoute('/_authenticated/customers/groups/create')(
  {
    component: RouteComponent
  }
);

function RouteComponent() {

  const [form] = useForm();
  const type = Form.useWatch('type', form);

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createGroup = useMutation({
    mutationFn: async (variables: { name: string, type: CustomersGroupType, rules: any | undefined }) => (
      await apiV1.post<{ id: string }>('/shop/customers/groups', variables)
    ),
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['customers-groups'] });
      navigate({ to: '/customers/groups/$groupId', replace: true, params: { groupId: data.id } });
    }
  });

  return (
    <div className={'p-4 max-w-lg m-auto'}>
      <BackButton className={'mb-5'} fallBackRouteOptions={{ to: '/customers/groups' }} />
      <h1 className={'mb-5 font-medium text-xl flex items-center gap-2'}><IconUsersGroup size={20} />Nuovo Gruppo</h1>
      <Form onFinish={createGroup.mutate} form={form} initialValues={{ type: 'automatic' }} layout={'vertical'}>
        <Form.Item required={false} rules={zodToAntdRules(z.string().min(1, 'Inserisci un nome valido'))}
                   name={'name'} label={'Nome'}>
          <Input size={'large'} placeholder={'Utenti Affezionati'} />
        </Form.Item>
        <Form.Item label={'Tipo di Gruppo'} name={'type'}>
          <RadioCards
            options={[
              {
                value: 'automatic',
                label: 'Automatico',
                description: 'I gruppi automatici aggiungono gli utenti in modo dinamico, seguendo regole configurabili qui sotto. La composizione del gruppo si aggiorna costantemente in base alle regole impostate.',
                icon: <HugeiconsIcon icon={AiBrain01Icon} />
              },
              {
              value: 'manual',
              label: 'Manuale',
              description: 'In un gruppo manuale puoi selezionare direttamente i clienti che ne fanno parte, decidendo uno a uno chi includere.',
              icon: <HugeiconsIcon icon={Hold01Icon} />
            }]} />
        </Form.Item>
        {
          type === 'automatic' &&
          <>
          <Form.Item label={'Modelli'} name={'presets'}>
            <RadioCards
              options={[
                {
                  value: 'new_customers',
                  label: 'Nuovi clienti',
                  description: 'Clienti che hanno aggiunto il tuo negozio da meno di una settimana.',
                  icon: <HugeiconsIcon icon={AddTeam02Icon} />
                }, {
                  value: 'recent_visits',
                  label: 'Visite recenti',
                  description: "Clienti che hanno visitato il negozio nell'ultima settimana",
                  icon: <HugeiconsIcon icon={Clock02Icon} />
                }, {
                  value: 'buyers',
                  label: 'Giovani',
                  description: 'Clienti con meno di 30 anni.',
                  icon: <HugeiconsIcon icon={BirthdayCakeIcon} />
                }, {
                  value: 'custom',
                  label: 'Personalizzato',
                  description: 'Scegli regole personalizzate',
                  icon: <HugeiconsIcon icon={Edit01Icon} />
                }]} />
          </Form.Item>
          <Form.Item
          name="rules"
          label="Regole"
          /*rules={[
            {
              validator: async (_, value) => {
                const result = z.array(customerFilterSchema).safeParse(value);
                if (!result.success) throw new Error('One or more filters are invalid');
              },
            },
          ]}*/
          >
          <FilterBuilder />
          </Form.Item>
          </>
        }

        <Form.Item>
          <Button htmlType={'submit'} type={'primary'} className={'w-full mt-4'} size={'large'}>Crea gruppo</Button>
        </Form.Item>

      </Form>
    </div>
  );
}
